module.exports = __webpack_public_path__ + "static/media/download.d7a0bb9d.svg";